import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { ViewModelDadosInstitutos } from 'app/main/content/shared/models/ViewModelDadosInstitutos.model';
import { ViewModelDadosModulos } from 'app/main/content/shared/models/ViewModelDadosModulos.model';
import { ViewModelProcessoWebModulosTextos } from 'app/main/content/shared/models/ViewModelProcessoWebModulosTextos.model';
import { Plano } from 'app/main/content/shared/models/plano.model';
import { WebModulosTextos } from 'app/main/content/shared/models/webModulosTextos.model';
import { EsteiraService } from 'app/main/content/shared/services/esteira.service';
import { PlanoService } from 'app/main/content/shared/services/plano.service';
import { ProcessoService } from 'app/main/content/shared/services/processo.service';
import { WebModulosTextosService } from 'app/main/content/shared/services/webModulosTextos.service';
import { WebProcessoControleService } from 'app/main/content/shared/services/webProcessoControle.service';
import { LoginStore } from 'app/main/content/shared/store/login.store';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

@Component({
    selector: 'app-modal-mensagem',
    templateUrl: './modal-mensagem.component.html',
    styleUrls: ['./modal-mensagem.component.scss']
})
export class ModalMensagemComponent implements OnInit {

    [x: string]: any;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    webModulosTextos: WebModulosTextos = new WebModulosTextos();
    lista_Modulo: ViewModelDadosModulos[] = [];
    lista_Instituto: ViewModelDadosInstitutos[] = [];
    lista_Plano: Plano[] = [];
    displayedColumns: string[] = ['Modulo', 'Plano', 'Instituto', 'Mensagem', 'Acao',];
    selection = new SelectionModel<any>(true, []);
    dataSource = new MatTableDataSource<any>();
    loading = false;
    selectedModulo: number;
    selectedPlano: number;
    selectedInstituto: number;
    dataInicio: string;
    dataFim: string;
    idPessoaLogada: number;
    ListaIdPessoa: number[];
    isDateFormat: boolean = environment.isDateFormat;
    nmTexto: string;
    isEdicao = false;

    nrCpf: string;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { modo: string, objeto: ViewModelProcessoWebModulosTextos },
        private planoService: PlanoService,
        private webModulosTextosService: WebModulosTextosService,
        private _snackBar: MatSnackBar,
        private loginStore: LoginStore,
        private dialogRef: MatDialogRef<ModalMensagemComponent>,
    ) {

    }

    ngOnInit() {
        this.loginStore.getCurrent().subscribe(retorno => {
            this.idPessoaLogada = retorno.idPessoa;
        });

        this.dataSource.paginator = this.paginator;

        this.loadPlano();
        this.loadInstituto();
        this.loadModulo();

        // Se for modo edição, preenche tudo
        if (this.data.modo === 'editar' && this.data.objeto) {
            this.isEdicao = true;
            const obj = this.data.objeto;

            // Define os valores iniciais dos selects
            this.selectedModulo = obj.idModulos;
            this.selectedPlano = obj.idPlano;
            this.selectedInstituto = obj.idInstitutos;

            // Preenche o texto da mensagem
            this.nmTexto = obj.nmTexto;
        }

        // let obj = JSON.parse(localStorage.getItem('search'));

        // if (obj != null) {
        //     this.selectedProcesso = obj.selectedProcesso;
        //     this.selectedSituacao = obj.selectedSituacao;
        //     this.selectedPlano = obj.selectedPlano;
        //     this.dataInicio = obj.dataInicio;
        //     this.dataFim = obj.dataFim;
        //     this.selectedOrderBy = obj.selectedOrderBy;
        //     // this.cpf = obj.cpf;
        //     // this.applyFilter(obj.cpf);
        //     this.filtroBuscaAdesao();
        // }

    }

    criaMensagem() {
        // Validação antes de tentar salvar
        if (!this.selectedModulo || !this.selectedPlano || !this.selectedInstituto) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Por favor, selecione o Módulo, o Plano e o Instituto antes de salvar.',
                confirmButtonColor: '#630a0c',
                confirmButtonText: 'Entendi',
                width: '600px',          // 🔹 Aumenta largura do alerta
                padding: '1.5rem',       // 🔹 Aumenta o espaçamento interno
                customClass: {
                    popup: 'modal-alerta', // 🔹 Classe customizada para estilização adicional
                },
            });
            return;
        }

        this.loading = true;

        this.webModulosTextos.institutos = this.initializeInstitutos();
        this.webModulosTextos.modulos = this.initializeModulos();
        this.webModulosTextos.plano = this.initializePlano();

        this.webModulosTextos.institutos.idInstitutos = this.selectedInstituto;
        this.webModulosTextos.modulos.idModulos = this.selectedModulo;
        this.webModulosTextos.plano.idPlano = this.selectedPlano;
        this.webModulosTextos.nmTexto = this.nmTexto;

        if (this.webModulosTextos.modulos.idModulos == 22) {
            this.webModulosTextos.icTravaUltimoDia = "S";
        } else {
            this.webModulosTextos.icTravaUltimoDia = "N";
        }

        // Criar ou editar conforme o modo
        if (this.data.modo === 'novo') {
            this.webModulosTextos.idSeq = 0;
            this.webModulosTextosService.Criar(this.webModulosTextos).subscribe(
                mensagem => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Sua mensagem foi salva!',
                        confirmButtonColor: '#630a0c',
                        confirmButtonText: 'Confirmar',
                        width: '600px',          // 🔹 Aumenta largura do alerta
                        padding: '1.5rem',       // 🔹 Aumenta o espaçamento interno
                    });
                    this.dialogRef.close('sucesso');
                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro!',
                        text: 'Ocorreu um erro ao salvar a mensagem.',
                        confirmButtonColor: '#630a0c',
                        confirmButtonText: 'Confirmar',
                        width: '600px',          // 🔹 Aumenta largura do alerta
                        padding: '1.5rem',       // 🔹 Aumenta o espaçamento interno
                    });
                }
            );
        } else {
            this.webModulosTextos.idSeq = this.data.objeto.idSeq;
            this.webModulosTextosService.editar(this.webModulosTextos).subscribe(
                mensagem => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: 'Sua mensagem foi atualizada!',
                        confirmButtonColor: '#630a0c',
                        confirmButtonText: 'Confirmar',
                    });
                    this.dialogRef.close('sucesso');
                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro!',
                        text: 'Ocorreu um erro ao atualizar a mensagem.',
                        confirmButtonColor: '#630a0c',
                        confirmButtonText: 'Confirmar',
                    });
                }
            );
        }
    }



    private initializeInstitutos(): ViewModelDadosInstitutos {
        return {
            idInstitutos: 0,
            nmInstitutos: '',
            idSeq: 0,
        };
    }

    private initializeModulos(): ViewModelDadosModulos {
        return {
            idModulos: 0,
            nmModulos: '',
            idSeq: 0,
        };
    }

    private initializePlano(): Plano {
        return {
            idPlano: 0,
            nmPlano: '',
            nrPlanoSpc: '',
            idSeq: 0
        };
    }



    loadPlano() {
        this.planoService.getAll().subscribe(plano => {
            this.lista_Plano = plano.filter(p => p.idPlano !== 0);
        })
    }

    loadInstituto() {
        this.webModulosTextosService.RetornaListaComboInstitutosService().subscribe(instituto => {
            this.lista_Instituto = instituto;
        });

    }

    loadModulo() {
        this.webModulosTextosService.RetornaListaComboModulos().subscribe(modulo => {
            this.lista_Modulo = modulo;
        });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }




    // /** Selects all rows if they are not all selected; otherwise clear selection. */
    // masterToggle() {
    //     this.isAllSelected() ?
    //         this.selection.clear() :
    //         this.dataSource.data.forEach(row => this.selection.select(row));
    // }



    clear() {
        this.selectedInstituto = undefined;
        this.selectedModulo = undefined;
        this.selectedPlano = undefined;
        //this.dialogRef.close();
        //this.clear();

    }


    // filtroBuscaAdesao() {
    //     // FILTRO ADESÃO
    //     this.loading = true;
    //     this.PostFiltro.idProcesso = this.selectedProcesso;
    //     this.PostFiltro.idStatus = this.selectedSituacao;
    //     this.PostFiltro.idPlano = this.selectedPlano;
    //     this.PostFiltro.dtInicio = this.dataInicio;
    //     this.PostFiltro.dtFim = this.dataFim;
    //     // this.PostFiltro.selectedOrderBy = this.selectedOrderBy;

    //     this.cpf = undefined;


    //     this.webProcessoControleService.FiltraProcesso(this.PostFiltro).subscribe(solicitacoes => {
    //         if (solicitacoes) {
    //             console.log(solicitacoes);
    //             this.dataSource = new MatTableDataSource<>(solicitacoes);
    //             this.dataSource.paginator = this.paginator;

    //             this.loading = false;
    //         }

    //     }, error => {
    //         this.openSnackBarError("Erro ao realizar a busca!" + error.error, 'X');
    //         this.loading = false;
    //     });

    // }



    // openSnackBar(message: string, action: string) {
    //     this._snackBar.open(message, action, {
    //         duration: 20000,
    //         panelClass: ['mat-toolbar', 'mat-success']
    //     });
    // }

    // openSnackBarError(message: string, action: string) {
    //     this._snackBar.open(message, action, {
    //         duration: 20000,
    //         panelClass: ['mat-toolbar', 'mat-warn']
    //     });
    // }

}
